export const coreHubTabAssets = {
  bronze: "hub__bronze-medal.png",
  silver: "hub__silver-medal.png",
  gold: "hub__gold-medal.png",
  platinum: "hub__platinum-medal.png",
  diamond: "hub__diamond-medal.png",
  disabled: "hub__disabled-medal.png",

  completeIcon: "hub__complete-icon.png",
  medalIcon: "hub__medal-icon.png",
  pointsIcon: "hub__points-icon.png",

  course1: "hub__one.jpg",
  course2: "hub__two.jpg",
  course3: "hub__three.jpg",
  course4: "hub__four.jpg",
  course5: "hub__five.jpg",
};

export const coreHubAssets = {
  genAiVideo: "hub__genai-video.mp4",
  aboutThumbnail: "hub__about-thumbnail.png",
  playIcon: "hub__play-visual.png",
};

export const learningHubAssets = {
  foundationActive: "hub__foundation.png",
  foundationInactive: "hub__foundation-inactive.png",
  aiActive: "hub__ai.png",
  aiInactive: "hub__ai-inactive.png",
  salesActive: "hub__sales.png",
  salesInactive: "hub__sales-inactive.png",
  deliveryActive: "hub__delivery.png",
  deliveryInactive: "hub__delivery-inactive.png",
  futureActive: "hub__future.png",
  futureInactive: "hub__future-inactive.png",
  productActive: "hub__product.png",
  productInactive: "hub__product-inactive.png",
  digitalActive: "hub__digitalcustomer.png",
  digitalInactive: "hub__digitalcustomer-inactive.png",

  lockIcon: "hub__lock.png",
  warningIcon: "hub__warning.png",
};

export const homePageAssets = {
  infoIcon: "home__info-icon.svg",
  aboutPoster: "home__about-thumbnail.png",
  aboutVideo: "home__inside-ignite-home-video-new.mp4",
  igniteTalksImg: "home__ignite-talks-img.png",
  ivaIcon: "home__iva-vertiual-text-icon-new.gif",
  ivaImage: "home__iva-vertiual-text-img.gif",
  teamIcon: "home__team-icon.png",
  popupGif: "home__onLoadGif.gif",

  team1: "team__core-saurabh.png",
  team2: "team__core5.png",
  team3: "team__core16.png",
  team4: "team__core-abhishek.png",
  team5: "team__core18.png",
  team6: "team__core4-new.png",
};

export const igniteTalkAssets = {
  speaker1: "igniteTalks__sunjeet-speaker.png",
  speaker2: "igniteTalks__prateek-speaker.png",
  speaker3: "igniteTalks__thom-cowell-speaker.jfif",

  thumb1: "igniteTalks__digi-cus-thumb1.png",
  thumb2: "igniteTalks__digi-cus-thumb2.png",
  thumb3: "igniteTalks__digi-cus-thumb3.png",
  thumb4: "igniteTalks__digi-cus-thumb4.png",
  thumb5: "igniteTalks__digi-cus-thumb5.png",
  thumb6: "igniteTalks__digi-cus-thumb6.png",
  thumb7: "igniteTalks__digi-cus-thumb7.png",
  thumb8: "igniteTalks__digi-cus-thumb8.png",

  agentThumb1: "igniteTalks__agentic-ai-thumb1.png",
  agentThumb2: "igniteTalks__agentic-ai-thumb2.png",
  agentThumb3: "igniteTalks__agentic-ai-thumb3.png",
  agentThumb4: "igniteTalks__agentic-ai-thumb4.png",
  agentThumb5: "igniteTalks__agentic-ai-thumb5.png",

  video1: "igniteTalks__fdcevideo1.mp4",
  video2: "igniteTalks__fdcevideo2.mp4",
  video3: "igniteTalks__fdcevideo3.mp4",
  video4: "igniteTalks__fdcevideo4.mp4",
  video5: "igniteTalks__fdcevideo5.mp4",
  video6: "igniteTalks__fdcevideo6.mp4",
  video7: "igniteTalks__fdcevideo7.mp4",
  video8: "igniteTalks__fdcevideo8.mp4",

  otherVideo1: "igniteTalks__othertalks1.mp4",
  otherVideo2: "igniteTalks__othertalks2.mp4",
  otherVideo3: "igniteTalks__othertalks3.mp4",
  otherVideo4: "igniteTalks__othertalks4.mp4",
  otherVideo5: "igniteTalks__othertalks5.mp4",

  digitalProductVideo1: "igniteTalks__digitalproduct1.mp4",
  digitalProductVideo2: "igniteTalks__digitalproduct2.mp4",
  digitalProductVideo3: "igniteTalks__digitalproduct3.mp4",
  digitalProductVideo4: "igniteTalks__digitalproduct4.mp4",
  digitalProductVideo5: "igniteTalks__digitalproduct5.mp4",
  digitalProductVideo6: "igniteTalks__digitalproduct6.mp4",

  digitalProductThumb1: "igniteTalks__digitalproduct-thumb1.png",
  digitalProductThumb2: "igniteTalks__digitalproduct-thumb2.png",
  digitalProductThumb3: "igniteTalks__digitalproduct-thumb3.png",
  digitalProductThumb4: "igniteTalks__digitalproduct-thumb4.png",
  digitalProductThumb5: "igniteTalks__digitalproduct-thumb5.png",
  digitalProductThumb6: "igniteTalks__digitalproduct-thumb6.png",
  bannerIgniteTalks: "banner__IgniteTalks.png",
};

export const teamAssets = {
  teamLeaders1: "igniteTalks__shridhar.png",
  teamLeaders2: "igniteTalks__saurabh.png",
  teamCore1: "igniteTalks__nisha.png",
  teamCore2: "igniteTalks__sindhu.png",
  teamCore3: "igniteTalks__mohana.png",
  teamCore4: "igniteTalks__abhishek.png",
  teamCore5: "igniteTalks__tinu.png",
  teamCore6: "igniteTalks__avneesh.png",
  teamPlatform1: "igniteTalks__nishtha.png",
  teamPlatform2: "igniteTalks__sucharitha.png",
  teamPlatform3: "igniteTalks__sambeet.png",
  teamPlatform4: "igniteTalks__taranjeet.png",
  teamPlatform5: "igniteTalks__kalpana.png",
  teamPlatform6: "igniteTalks__smitha.png",
  teamPlatform7: "igniteTalks__harini.png",
  teamPlatform8: "igniteTalks__varsha.png",
  teamPlatform9: "igniteTalks__ashu.png",
  teamPlatform10: "igniteTalks__sheela.png",
  teamPlatform11: "igniteTalks__chethak.png",
  teamAdoption1: "igniteTalks__avathar.png",
  teamAdoption2: "igniteTalks__rekha.jpg",
  teamAdoption3: "igniteTalks__avathar.png",
  teamAdoption4: "igniteTalks__ashwin.jpg",
  teamAdoption5: "igniteTalks__krithika.jpg",
  teamAdoption6: "igniteTalks__avathar.png",
  teamAdoption7: "igniteTalks__praneeth.jpg",
  teamAdoption8: "igniteTalks__amit.jpg",
  teamAdoption9: "igniteTalks__avathar.png",
  teamAdoption10: "igniteTalks__joel.jpg",
  teamAdoption11: "igniteTalks__avathar.png",
  teamHubs1: "igniteTalks__avathar.png",
  teamHubs2: "igniteTalks__jaya.jpg",
  teamHubs3: "igniteTalks__avathar.png",
  teamHubs4: "igniteTalks__avathar.png",
  teamHubs5: "igniteTalks__shyamala.jpg",
  teamHubs6: "igniteTalks__avathar.png",
  bannerTeam: "banner__Team.png",
};

export const aboutIgniteAssets = {
  aboutCarnival: "about__carnival.png",
  aboutVisionImg: "about__VisionImg.png",
  aboutDesignImg: "about__DesignImg.png",
  aboutFoundationIcon: "about__FoundationIcon.png",
  aboutSurveyIcon: "about__SurveyIcon.png",
  aboutFlagshipIcon: "about__FlagshipIcon.png",
  aboutCommunicationIcon: "about__CommunicationIcon.png",
  aboutVisionGradient: "about__VisionGradient.png",
  bannerAboutIgnite: "banner__AboutIgnite.png",
};

export const faqAssets = {
  faqUpArrow: "faq__UpArrow.png",
  faqDownArrow: "faq__DownArrow.png",
  faqQuestion: "faq__Question.png",
  bannerFAQ: "banner__FAQ.png",
};

export const learnhubAssets = {
  bannerLearnHub: "banner__LearnHub.png",
};

export const dashboardAssets = {
  bannerDashboard: "banner__Dashboard.png",
  coursesIcon: "dashboard__courses-icon.png",
  pointsIcon: "dashboard__points-icon.png",
  badgesIcon: "dashboard__badges-icon.png",
  oneStepImg: "dashboard__one-step-img.png",
  badgesLockkey: "dashboard__badges-lock-key.png",
  milestoneCompleteicon: "dashboard__milestone-complete-icon.png",
  milestoneLockicon: "dashboard__milestone-lock-icon.png",
  continueLearningicon: "dashboard__continue-learning-icon.png",
  moduleCompleteicon: "dashboard__module-complete-icon.png",
  moduleProgressicon: "dashboard__module-progress-icon.png",
  modulePendingicon: "dashboard__module-pending-icon.png",

  FoundationActive: "dashboard__foundation.png",
  FoundationInactive: "dashboard__foundation-inactive.png",

  AIActive: "dashboard__ai.png",
  AIInactive: "dashboard__ai-inactive.png",

  SalesActive: "dashboard__sales.png",
  SalesInactive: "dashboard__sales-inactive.png",

  ProductActive: "dashboard__product.png",
  ProductInactive: "dashboard__product-inactive.png",

  DeliveryActive: "dashboard__delivery.png",
  DeliveryInactive: "dashboard__delivery-inactive.png",

  FutureActive: "dashboard__future.png",
  FutureInactive: "dashboard__future-inactive.png",

  DigitalCustomerActive: "dashboard__digital-customer.png",
  DigitalCustomerInactive: "dashboard__digital-customer-inactive.png",
};

export const hallfameAssets = {
  bannerHallFame: "banner__HallFame.png",
};
